<!--
Important:
This Component is used only for the Vue3 application
Any modifications made should be done for Vue2 component also
Vue2File: wwwroot\js\WebsitePrimary\components\VehicleCount\VehicleCount.vue
Dont forget to make the changes in both the files
Any clarifications contact Laxman
-->
<!--note:
-----
common for primary and simplify templates-->

<template>
  <div
    v-if="inventoryVehicledetails"
    v-equal-height="setMatchHeightData.el"
    class="container vehicle-models-count inventory-slick-section g-page-section"
    :class="heading ? 'vehicle-inventory-slick-section' : ''"
  >
    <div
      class="vehicle-title-wrapper"
      :class="
        getHeading.trim() || getSubHeading.trim() || enableCountOnPrimaryControl ? 'my-4' : ''
      "
    >
      <strong class="vehicle-count-title">{{ getHeading }}</strong>

      <a
        href="/inventory"
        class="ft-12 color-black mr-3 rotational-coupon-service-link cust-link btn-websites button-link text-center text-capitalize d-block text-underline"
        @click="onSubHeadingClick()"
      >
        {{ getSubHeading }}
      </a>

      <!--simplify template-->
      <!--primary template-->
      <span>
        <a
          v-if="enableCountOnPrimaryControl"
          class="no-hover color-black hover-color _theme_font_bold"
          :href="`/inventory/${
            inventoryVehicledetails.newModels[0].vehicles.certified
              ? 'cpo'
              : inventoryVehicledetails.newModels[0].vehicles.type.toLowerCase()
          }`"
          @click="
            onCommonLinkLogs(
              inventoryVehicledetails.totalVehicleCount,
              `/inventory/${
                inventoryVehicledetails.newModels[0].vehicles.certified
                  ? 'cpo'
                  : inventoryVehicledetails.newModels[0].vehicles.type.toLowerCase()
              }`
            )
          "
        >
          <span class="vehicle-total-count">{{ inventoryVehicledetails.totalVehicleCount }}</span>
        </a>
      </span>
      <!--primary template-->
    </div>
    <VSlickCarousel
      ref="slick"
      v-bind="slickOptions"
      @beforeChange="handleBeforeChange"
      @afterChange="afterChangeWrapper"
    >
      <template #prevArrow="arrowSlotProps">
        <div
          @click="
            slickDirection = 'previous';
            arrowSlotProps.onClick();
          "
          :disabled="arrowSlotProps.disabled"
        >
          <em class="primaryicon-left-arrow slick-arrow" style="cursor: pointer; z-index: 1"></em>
        </div>
      </template>
      <template #nextArrow="arrowSlotProps">
        <div
          @click="
            slickDirection = 'next';
            arrowSlotProps.onClick();
          "
          :disabled="arrowSlotProps.disabled"
        >
          <em
            class="primaryicon-right-arrow bgcolor-primary _msbi_background_color slick-arrow"
            style="color: #cccccc; cursor: pointer; z-index: 1"
          ></em>
        </div>
      </template>
      <a
        v-for="(vehicle, index) in inventoryVehicledetails.newModels"
        :key="index"
        :href="`${vehicle.vehicles.url}`"
        class="inventory-vehicle-block no-hover color-primary theme-text-color"
        @click="logTagLinkClickEvents(vehicle)"
      >
        <div class="w-75 mx-auto">
          <div
            class="align-items-center d-flex justify-content-center mt-3"
            v-if="enableCountOnPrimaryControl"
          >
            <div
              class="font-weight-bold text-center grey-text inventory-vehicle-count _theme_font_bold mr-2"
              :class="[inventoryCountLabel ? 'ft-20' : 'count-label-default']"
            >
              {{ vehicle.count }}
            </div>
            <div
              v-if="inventoryCountLabel"
              class="font-weight-bold text-center grey-text inventory-vehicle-count _theme_font_bold ft-20"
            >
              {{ inventoryCountLabel }}
            </div>
          </div>
          <div class="inventory-image">
            <img
              v-if="useoverrides"
              :src="`${vehicle.vehicles.photoURLs}&angle=01&width=350&colorcode=${vehicle.vehicles.extColorCode}&quality=85&useoverrides=${useoverrides}&type=jpeg`"
              class="img-fluid"
              :width="imageWidth"
              :height="imageHeight"
              :alt="`${vehicle.vehicles.year} ${vehicle.vehicles.make} ${vehicle.vehicles.model}`"
            />
            <img
              v-else
              :src="`${vehicle.vehicles.photoURLs}&angle=01&width=350&colorcode=${vehicle.vehicles.extColorCode}&quality=85&type=jpeg`"
              class="img-fluid"
              :width="imageWidth"
              :height="imageHeight"
              :alt="`${vehicle.vehicles.year} ${vehicle.vehicles.make} ${vehicle.vehicles.model}`"
            />
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <div class="text-center py-3 position-relative coupon-fixed-btn count-img-box">
            <div class="ft-16 text-dark vehicle-model-name">
              <strong>
                {{ vehicle.vehicles.year }} {{ vehicle.vehicles.make }}
                {{ vehicle.vehicles.model }}
              </strong>
            </div>

            <div v-if="showCallForPriceSRP" class="grey-text">
              <a v-if="isMobile" class="no-hover" :href="'tel:' + salesnumber">
                <span class="grey-text cursor-pointer"> Call For Price</span>
              </a>
              <span v-else class="grey-text"> Call For Price</span>
            </div>
            <div v-else-if="!hidePricing">
              <div
                v-if="useSellingPriceOnInventoryControl && vehicle.vehicles.yourPrice"
                class="color-black ft-12"
              >
                Starting at ${{ getThousandSeperator(vehicle.vehicles.yourPrice) }}
              </div>
              <div v-else-if="vehicle.vehicles.msrp" class="color-black ft-12">
                Starting at ${{ getThousandSeperator(vehicle.vehicles.msrp) }}
              </div>
              <div v-else-if="vehicle.vehicles.yourPrice" class="color-black ft-12">
                Starting at ${{ getThousandSeperator(vehicle.vehicles.yourPrice) }}
              </div>
              <div v-else>
                <span class="grey-text">Call For Price</span>
              </div>
            </div>
          </div>
        </div>
      </a>
    </VSlickCarousel>
    <!--simplify template-->
    <div v-if="isSimplifyTemplate" class="text-center d-md-none">
      <a class="text-dark hover-color _theme_font_bold text-underline" href="/inventory/new">
        View All Vehicles
      </a>
    </div>
    <!--simplify template-->
  </div>
</template>

<script type="text/javascript">
import VehicleCount from "./VehicleCount";
export default {
  mixins: [VehicleCount],
};
</script>

<style>
.inventory-vehicle-block {
  border: 1px solid transparent;
  border-bottom: 4px solid transparent;
}
.vehicle-models-count .vehicle-title-wrapper {
  font-size: 32px;
  text-align: center;
}

.inventory-vehicle-block:hover {
  border: 1px solid #ccc;
  border-bottom: 4px solid;
  cursor: pointer;
}

.inventory-vehicle-block:hover .inventory-vehicle-count,
.no-hover:hover .inventory_total_count {
  color: #000 !important;
}

.img-ht {
  max-height: 70px;
  margin: 0 auto;
}
@media (max-width: 700px) {
  .inventory-vehicle-block {
    min-height: initial;
  }

  .count-img-box {
    position: initial !important;
  }
}
.count-label-default {
  font-size: 5em;
  height: 75px;
  line-height: 75px;
}
</style>

<style scoped>
/* for slick */
.inventory-slick-section {
  padding: 0px 28px;
}

.inventory-slick-section :deep(.v-slick-arrow:before) {
  color: red;
}
</style>
